import { ChangeDetectorRef, Component, EventEmitter, Inject, OnDestroy, OnInit } from '@angular/core';
import { ProfileData } from '../../../models/profile/profile.model';
import { UserProfileShareService } from '../../../services/shared-service/user-profile-share.service';
import { Observable } from 'rxjs';
import { RESOURCES_DATA_SERVICE, ResourcesDataService } from '../../../services/resources/resources-data.service';
import { AddressHelper } from '../../../helper/address.helper';
import {
  ProgressSpinnerComponent
} from '../../shared-module/components/progress-spinner/progress-spinner.component';
import { MatDialog } from '@angular/material/dialog';

import { Select, Store } from '@ngxs/store';
import { LoaderState } from '../../store/loader/loader.state';
import { takeUntil } from 'rxjs/operators';
import { Router } from "@angular/router";
import { CLOUD_DATA_SERVICE, CloudDataService } from '../../../services/cloud/cloud-data.service';
import { AdminMandant } from '../../../models/cloud/cloud.model';
import { ActionHelper } from '../../../helper/action.helper';


@Component({
  templateUrl: './app-frame.component.html',
  styleUrls: ['./app-frame.component.scss'],
  standalone: false,
})

export class AppFrameComponent implements OnInit, OnDestroy {
  @Select(LoaderState.loading) loading$: Observable<boolean>;

  takeUntil$ = new EventEmitter();

  profileData: Observable<ProfileData>;
  progress: ProgressSpinnerComponent;
  adminMandant?: AdminMandant;

  private dialogElement: any;
  private static globalDialog: MatDialog;
  private static warningDialogOpened = false;


  constructor(
    @Inject(RESOURCES_DATA_SERVICE) private readonly resourceDataService: ResourcesDataService,
    @Inject(CLOUD_DATA_SERVICE) private readonly cloudDataService: CloudDataService,
    private readonly sharedProfileService: UserProfileShareService,
    private dialog: MatDialog,
    private store: Store,
    private router: Router,
    private ref: ChangeDetectorRef,
  ) {
    AppFrameComponent.globalDialog = this.dialog;

    this.profileData = this.sharedProfileService.getProfile();

    resourceDataService.getResourceCountries().subscribe(({success, data}) => {
      if (success) {
        AddressHelper.setCountries(data);
      }
    });

    const subscription = sharedProfileService.getAdminMandant().subscribe((data) => {
      if (data) {
        this.adminMandant = data;
        setTimeout(() => {
          subscription?.unsubscribe();
        });
      }
    });

    this.loading$.pipe(
      takeUntil(this.takeUntil$),
    ).subscribe( loading => {
      if (loading) {
        this.openLoaderDialog();
      } else {
        this.closeLoaderDialog();
      }
    });

    window.addEventListener('beforeunload', (event) => {
      if (ActionHelper.hasUnsavedChanges()) {
        event.preventDefault();
        event.returnValue = true;
      }
    })
  }


  static warnAboutUnsavedChanges(callback: (confirmed: boolean) => any): void {
    if (this.warningDialogOpened) {
      callback(false);
      return;
    }

    this.warningDialogOpened = true;

    ActionHelper.showAction('DELETE-CONFIRM', this.globalDialog, {
      customMessageSnippet: 'REQUEST_CREATE_MESSAGE_UNSAVED_TITLE',
      customDescriptionSnippet: 'REQUEST_CREATE_MESSAGE_UNSAVED_DESCRIPTION',
      customConfirmSnippet: 'REQUEST_CREATE_MESSAGE_UNSAVED_BUTTON_SAVE',
      customCancelSnippet: 'REQUEST_CREATE_MESSAGE_UNSAVED_BUTTON_DISCARD',
      customConfirmValue: 'confirm',
      customCancelValue: 'cancel',
    })?.afterClosed().subscribe(data => {
      this.warningDialogOpened = false;

      if (data === 'cancel') {
        ActionHelper.clearUnsavedChanges();
      }
      callback(data === 'cancel');
    });
  }

  ngOnInit(): void {
    if (location.search && location.search.includes('?q=')) {
      const rootUrl = location.protocol + '//' + location.host;
      window.history.replaceState('', '', rootUrl);
      this.router.navigate(['/'], { queryParams: { } });
    }
  }

  ngOnDestroy(): void {
    this.takeUntil$?.emit();
  }

  private openLoaderDialog(): void {
    this.dialogElement = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      closeOnNavigation: false,
      width: '100%',
      height: '100%',
      panelClass: 'progress-bar-overlay'
    });
  }

  private closeLoaderDialog(): void {
    this.dialogElement?.close();
  }
}
